<template>
  <div>
    <ComponentHeader
      title="Entity Reconciliation"
      :subtitle="activeSubTabDescription"
    />

    <div class="pt-2">
      <div class="flex gap-1 border-b border-gray-200">
        <button
          v-for="t in subTabs"
          :key="t.key"
          class="px-4 py-2 text-xs border-b-2 -mb-px"
          :class="activeSubTab === t.key
            ? 'border-blue-600 text-blue-600 font-medium'
            : 'border-transparent text-gray-600 hover:text-gray-900'"
          @click="activeSubTab = t.key"
        >{{ t.label }}</button>
      </div>
    </div>

    <ReconciliationAssignment v-if="activeSubTab === 'assignment'" />
    <ReconciliationUnsupported v-if="activeSubTab === 'unsupported'" />
  </div>
</template>

<script>
import ComponentHeader from '@/components/widgetcomponents/library/ComponentHeader.vue';
import ReconciliationAssignment from '@/components/ETL_Utility/Reconciliation/Reconciliation_Assignment.vue';
import ReconciliationUnsupported from '@/components/ETL_Utility/Reconciliation/Reconciliation_Unsupported.vue';

export default {
  name: 'OverviewETLReconciliation',
  components: { ComponentHeader, ReconciliationAssignment, ReconciliationUnsupported },
  data() {
    return {
      activeSubTab: 'assignment',
      subTabs: [
        {
          key: 'assignment',
          label: 'Assignment Coverage',
          description: 'Provider combinations patients are assigned to, and whether the app holds that relationship',
        },
        {
          key: 'unsupported',
          label: 'Unsupported Links',
          description: 'Staff parented to a TIN with no assignment or claims evidence behind it',
        },
      ],
    };
  },
  created() {
    // Restore only if the remembered key still exists — the keys have changed
    // before, and a stale value renders a blank pane.
    const saved = localStorage.getItem('entity_reconciliation_subtab');
    if (this.subTabs.some((t) => t.key === saved)) {
      this.activeSubTab = saved;
    }
  },
  computed: {
    activeSubTabDescription() {
      const t = this.subTabs.find((x) => x.key === this.activeSubTab);
      return t ? t.description : '';
    },
  },
  watch: {
    activeSubTab(v) {
      localStorage.setItem('entity_reconciliation_subtab', v);
    },
  },
};
</script>
